import axios from '../utils/axios';

export default function deactivateSeekerSubscriptions(adminId,data) {
    return (
        axios.post('/admin/' + adminId + '/manageSeekerSubscriptions/v2/admin/deActivateSubscription', data )
    )
}
